import React, { useEffect } from 'react'
import Header from '../Header/Main'
import Banner from '../Menhome/Banner'
import UserBenefits from '../Menhome/UserBenefits'
import About from '../Menhome/About'
import Textlist from '../Menhome/Textlist'
import Service from '../Menhome/Service'
import HowWork from '../Menhome/HowWork'
import Review from '../Menhome/Review'
import Clients from '../Menhome/Clients'
import Pricing from '../Menhome/Pricing'
import Interface from '../Menhome/Interface'
import Text from '../Menhome/Text'
import Blog from '../Menhome/Blog'
import Footer from '../Footer/Main'
import Aos from 'aos'


// Data
import heroBannerData from '../../data/heroBanner.json';


function Main() {

    useEffect(() => {
        Aos.init();
        Aos.refresh();
    }, []);

    return (
        <>
            <Header />
            <Banner 
                typeAnimationDataPhrases={heroBannerData.sequence} 
                typeAnimationTypingSpeed={heroBannerData.typingSpeed}
                typeAnimationDeletionSpeed={heroBannerData.deletionSpeed}
                typeAnimationPauseTime={heroBannerData.pauseTime}
            />
            <UserBenefits />
            <div className='page_wrapper'>
                <About />
                {/*<Textlist /> */}
                <Service />
                <HowWork />
            </div>
            <Interface />

            <div className='page_wrapper'>
                <Text />
                <Review />
                <Clients />
                {/*<Pricing />*/}
                
                
                <Blog />
                <Footer />
            </div>
        </>
    )
}

export default Main